/* =====================================================
  Bioteïne - Mix & match picker
  Works with BT.CartDrawer (bioteine-cart.js). Adds the whole
  selection in one /cart/add.js request, then lets the existing
  cart logic refresh, open the drawer and fire its events.
  No prices are computed for checkout - Shopify stays the source.
  ===================================================== */
(function () {
  'use strict';
  if (window.BTMixMatch) return;
  window.BTMixMatch = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    if (window.BT && typeof BT.formatMoney === 'function') return BT.formatMoney(cents);
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function cartTotal() {
    var c = window.BT && BT.CartDrawer && BT.CartDrawer.cart;
    return c ? (c.total_price || 0) : 0;
  }

  function MixMatch(el) {
    this.el = el;
    this.ctx = el.dataset.context || 'pdp';
    this.thr = parseInt(el.dataset.shipThreshold || '0', 10);
    this.t = {
      shipMore: el.dataset.tShipMore || '',
      shipFree: el.dataset.tShipFree || '',
      addSel: el.dataset.tAddSel || '',
      pick: el.dataset.tPick || '',
      added: el.dataset.tAdded || '',
      error: el.dataset.tError || '',
      selected: el.dataset.tSelected || ''
    };
    this.track = el.querySelector('[data-bt-mm-track]');
    this.cards = Array.prototype.slice.call(el.querySelectorAll('[data-bt-mm-card]'));
    this.btn = el.querySelector('[data-bt-mm-add]');
    this.label = el.querySelector('[data-bt-mm-cta-label]');
    this.totalEl = el.querySelector('[data-bt-mm-total]');
    this.countEl = el.querySelector('[data-bt-mm-count]');
    this.shipEl = el.querySelector('[data-bt-mm-ship]');
    this.shipFill = el.querySelector('[data-bt-mm-ship-fill]');
    this.prev = el.querySelector('[data-bt-mm-prev]');
    this.next = el.querySelector('[data-bt-mm-next]');
    this.state = {}; // variantId -> { qty, price }
    this.busy = false;
    this.bind();
    this.render();
    this.updateArrows();
  }

  MixMatch.prototype.bind = function () {
    var self = this;
    this.el.addEventListener('click', function (e) {
      var card = e.target.closest('[data-bt-mm-card]');
      if (e.target.closest('[data-bt-mm-pick]') && card) { e.preventDefault(); self.change(card, 1); return; }
      if (e.target.closest('[data-bt-mm-inc]') && card) { e.preventDefault(); self.change(card, 1); return; }
      if (e.target.closest('[data-bt-mm-dec]') && card) { e.preventDefault(); self.change(card, -1); return; }
      if (e.target.closest('[data-bt-mm-prev]')) { self.scrollBy(-1); return; }
      if (e.target.closest('[data-bt-mm-next]')) { self.scrollBy(1); return; }
    });
    this.btn && this.btn.addEventListener('click', function () { self.submit(); });
    if (this.track) {
      var raf = null;
      this.track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; self.updateArrows(); });
      }, { passive: true });
      window.addEventListener('resize', function () { self.updateArrows(); }, { passive: true });
    }
    if (this.ctx !== 'pdp') {
      document.addEventListener('bt:cart:fetched', function (e) { self.syncWithCart(e.detail); });
      document.addEventListener('bt:cart:updated', function (e) { self.syncWithCart(e.detail); });
      if (window.BT && BT.CartDrawer && BT.CartDrawer.cart) this.syncWithCart(BT.CartDrawer.cart);
    } else {
      document.addEventListener('bt:cart:fetched', function () { self.render(); });
      document.addEventListener('bt:cart:updated', function () { self.render(); });
    }
  };

  MixMatch.prototype.scrollBy = function (dir) {
    if (!this.track) return;
    var card = this.cards.find(function (c) { return !c.hidden; });
    var step = card ? (card.getBoundingClientRect().width + 12) * 2 : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: dir * step, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  MixMatch.prototype.updateArrows = function () {
    if (!this.track || !this.prev || !this.next) return;
    var max = this.track.scrollWidth - this.track.clientWidth - 2;
    var scrollable = max > 4;
    this.el.classList.toggle('is-scrollable', scrollable);
    this.prev.disabled = !scrollable || this.track.scrollLeft <= 2;
    this.next.disabled = !scrollable || this.track.scrollLeft >= max;
  };

  MixMatch.prototype.change = function (card, delta) {
    if (this.busy) return;
    var id = card.dataset.variantId;
    var price = parseInt(card.dataset.price || '0', 10);
    var s = this.state[id] || { qty: 0, price: price };
    s.qty = Math.max(0, Math.min(99, s.qty + delta));
    if (s.qty === 0) delete this.state[id]; else this.state[id] = s;

    var qtyEl = card.querySelector('[data-bt-mm-qty]');
    var stepper = card.querySelector('[data-bt-mm-stepper]');
    var pick = card.querySelector('[data-bt-mm-pick]');
    var on = s.qty > 0;
    card.classList.toggle('is-selected', on);
    if (qtyEl) {
      qtyEl.textContent = String(s.qty);
      if (!reduceMotion) { qtyEl.classList.remove('is-bump'); void qtyEl.offsetWidth; qtyEl.classList.add('is-bump'); }
    }
    if (stepper) {
      stepper.setAttribute('aria-hidden', on ? 'false' : 'true');
      stepper.querySelectorAll('button').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    }
    if (pick) {
      pick.tabIndex = on ? -1 : 0;
      pick.setAttribute('aria-hidden', on ? 'true' : 'false');
      if (!on && document.activeElement && card.contains(document.activeElement)) pick.focus({ preventScroll: true });
    }
    if (on && delta > 0 && stepper && document.activeElement === pick) {
      var inc = stepper.querySelector('[data-bt-mm-inc]');
      inc && inc.focus({ preventScroll: true });
    }
    this.render();
  };

  MixMatch.prototype.totals = function () {
    var self = this, count = 0, cents = 0;
    Object.keys(this.state).forEach(function (k) { count += self.state[k].qty; cents += self.state[k].qty * self.state[k].price; });
    return { count: count, cents: cents };
  };

  MixMatch.prototype.render = function () {
    var t = this.totals();
    this.el.classList.toggle('has-selection', t.count > 0);
    if (this.btn) this.btn.disabled = t.count === 0 || this.busy;
    if (this.countEl) this.countEl.textContent = t.count > 0 ? (t.count + ' ' + this.t.selected) : this.t.pick;
    if (this.totalEl) this.totalEl.textContent = t.count > 0 ? money(t.cents) : '';

    if (this.thr > 0 && this.shipEl) {
      var base = cartTotal();
      var after = base + t.cents;
      var pct = Math.max(0, Math.min(100, (after / this.thr) * 100));
      if (this.shipFill) {
        this.shipFill.style.transform = 'scaleX(' + (pct / 100) + ')';
        this.shipFill.classList.toggle('is-complete', after >= this.thr);
      }
      this.shipEl.textContent = after >= this.thr ? this.t.shipFree : this.t.shipMore.replace('%%a%%', money(this.thr - after));
    }
  };

  MixMatch.prototype.syncWithCart = function (cart) {
    if (!cart) return;
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[String(i.product_id)] = true; });
    var visible = 0, self = this;
    this.cards.forEach(function (c) {
      var hide = !!inCart[c.dataset.productId] && !self.state[c.dataset.variantId];
      c.hidden = hide;
      if (!hide) visible++;
    });
    var show = visible > 0 && (this.ctx === 'cart' || (cart.item_count || 0) > 0);
    if (this.el.hidden === show) {
      this.el.hidden = !show;
      if (show && !reduceMotion) { this.el.classList.remove('is-in'); void this.el.offsetWidth; this.el.classList.add('is-in'); }
    }
    this.render();
    this.updateArrows();
  };

  MixMatch.prototype.reset = function () {
    var self = this;
    this.state = {};
    this.cards.forEach(function (c) {
      c.classList.remove('is-selected');
      var q = c.querySelector('[data-bt-mm-qty]'); if (q) q.textContent = '0';
      var st = c.querySelector('[data-bt-mm-stepper]');
      if (st) { st.setAttribute('aria-hidden', 'true'); st.querySelectorAll('button').forEach(function (b) { b.tabIndex = -1; }); }
      var p = c.querySelector('[data-bt-mm-pick]'); if (p) { p.tabIndex = 0; p.setAttribute('aria-hidden', 'false'); }
    });
    self.render();
  };

  MixMatch.prototype.feedback = function (text, cls) {
    var self = this;
    if (!this.btn || !this.label) return;
    this.btn.classList.add(cls);
    this.label.textContent = text;
    if (this.totalEl) this.totalEl.textContent = '';
    setTimeout(function () {
      self.btn.classList.remove(cls);
      self.label.textContent = self.t.addSel;
      self.render();
    }, 1600);
  };

  MixMatch.prototype.submit = function () {
    var self = this;
    var items = Object.keys(this.state).map(function (k) { return { id: parseInt(k, 10), quantity: self.state[k].qty }; });
    if (!items.length || this.busy) return;
    this.busy = true;
    this.btn.classList.add('is-loading');
    this.btn.disabled = true;

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw new Error(e.description || self.t.error); });
      return r.json();
    }).then(function () {
      items.forEach(function (it) {
        document.dispatchEvent(new CustomEvent('bt:cart:added', { detail: { variantId: String(it.id), qty: it.quantity, source: 'mix-match' } }));
      });
      self.btn.classList.remove('is-loading');
      self.busy = false;
      self.reset();
      self.feedback(self.t.added, 'is-added');

      var D = window.BT && BT.CartDrawer;
      if (self.ctx === 'cart' || document.body.classList.contains('template-cart')) {
        setTimeout(function () { window.location.reload(); }, 700);
        return;
      }
      if (D) {
        D.fetch().then(function () {
          if (window.BT.Timer && D.settings) BT.Timer.reset(D.settings.reserveMinutes);
          if (self.ctx === 'pdp') D.open();
        });
      }
    }).catch(function (err) {
      self.busy = false;
      self.btn.classList.remove('is-loading');
      self.feedback(self.t.error, 'is-error');
      if (window.BT && BT.CartDrawer && BT.CartDrawer.showError) BT.CartDrawer.showError(err.message || self.t.error);
    });
  };

  function init() {
    document.querySelectorAll('[data-bt-mm]').forEach(function (el) {
      if (el.dataset.btMmBound) return;
      el.dataset.btMmBound = '1';
      new MixMatch(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
